// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { RegionEnum } from './region-enum';

// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class ReconcilliationRequestModel extends APIModel {
    regionId: RegionEnum;
    reconcilliationPeriodStart: string;
    reconcilliationPeriodEnd: string;
    bankPaymentsCsv: string;

    constructor(options?: APIModelOptions) {
        super(ReconcilliationRequestModel.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "regionId", type: "RegionEnum" },
            { name: "reconcilliationPeriodStart", type: "string" },
            { name: "reconcilliationPeriodEnd", type: "string" },
            { name: "bankPaymentsCsv", type: "string" }
        ];
    }
}




